import { beginTask, endTask } from 'redux-nprogress';
import { selectQuery } from '../../../../store/reducers/location.selectors';
import { loadWeeks, selectCurrent } from '../../../../store/reducers/season';
import { selectFormulasState } from '../../../../store/reducers/formula';
import { selectTeamsForDropdownAlpha } from '../../../../store/reducers/teams.selectors';
import {
  selectMatchupsState,
  loadMatchups } from '../../../../store/reducers/matchups';
import routes from '../../../routes.global';
import viewNames from '../../../../store/actions/view.types';
import { loadToolDescriptions } from '../../../../store/reducers/toolDescriptions';
// ------------------------------------
// Selectors
// ------------------------------------
export const STORE_KEY = 'boxScores';
export const selectBoxScoresState = state => state[STORE_KEY];

// ------------------------------------
// Reducer
// ------------------------------------
const actions = {};
const initialState = {
  boxScores: [],
  year: null,
  week: null,
  team: null,
  matchup: null,
  filterType: null,
  formulaId: 1,
  hasLoaded: false,
  error: null,
};

const boxScoresReducer = (state = initialState, action) => {
  const handler = actions[action.type];

  return handler ? handler(state, action) : state;
};

export default boxScoresReducer;

// ------------------------------------
// Actions
// ------------------------------------
export const LOAD_BOX_SCORES_REQUEST = `${STORE_KEY}/LOAD_BOX_SCORES_REQUEST`;
export const LOAD_BOX_SCORES_SUCCESS = `${STORE_KEY}/LOAD_BOX_SCORES_SUCCESS`;
export const LOAD_BOX_SCORES_ERROR = `${STORE_KEY}/LOAD_BOX_SCORES_ERROR`;

export const loadBoxScoresRequest = (year, formulaId, team, week, filterType, matchup) => ({
  type: LOAD_BOX_SCORES_REQUEST,
  payload: { year, formulaId, team, week, filterType, matchup },
});
export const loadBoxScoresSuccess = (boxScores) => ({
  type: LOAD_BOX_SCORES_SUCCESS,
  payload: { boxScores },
});
export const loadBoxScoresError = error => ({
  type: LOAD_BOX_SCORES_ERROR,
  payload: { error },
});

actions[LOAD_BOX_SCORES_REQUEST] = (
  state,
  { payload: { year, formulaId, team, week, filterType, matchup } },
) => ({ ...state,
  year,
  formulaId,
  team,
  week,
  filterType,
  matchup,
});
actions[LOAD_BOX_SCORES_SUCCESS] = (state, { payload: { boxScores } }) => ({ ...state,
  boxScores,
  hasLoaded: true,
});
actions[LOAD_BOX_SCORES_ERROR] = (state, { payload }) => ({ ...state,
  error: payload.error,
});

export const loadBoxScores = (
  year,
  formulaId,
  team,
  week,
  filterType,
  matchup,
) => async (dispatch, getState, { api }) => {
  try {
    dispatch(beginTask());
    dispatch(loadBoxScoresRequest(year, formulaId, team, week, filterType, matchup));

    const [response] = await Promise.all([
      (filterType === 'Weekly') ?
        api.stats.getWeeklyBoxScores({ year, formulaId, week, matchup }) :
        api.stats.getSeasonBoxScores({ year, formulaId, team }),
      dispatch(loadWeeks(year)),
    ]);
    dispatch(loadBoxScoresSuccess(response.gamescans));
  } catch (error) {
    // console.error(error);
    dispatch(loadBoxScoresError(error));
  } finally {
    dispatch(endTask());
  }
};

// ------------------------------------
// View / Route
// ------------------------------------
export const BOX_SCORES_VIEW = `${STORE_KEY}/BOX_SCORES_VIEW`;

viewNames[BOX_SCORES_VIEW] = 'BoxScores';
routes[BOX_SCORES_VIEW] = {
  path: '/stats/box-scores',
  thunk: async (dispatch, getState) => {
    const state = getState();
    let { year, formulaId, filterType, team, week, matchup } = selectQuery(state);

    if (!formulaId) formulaId = selectFormulasState(state).defaultFormula;
    if (year === null || year === undefined || year === 'null') year = selectCurrent(state, 'stats').season;
    if (!filterType) filterType = 'Season';
    if (!team) {
      team = selectTeamsForDropdownAlpha(state)[0].value;
    }
    if (typeof week !== 'number') week = selectCurrent(state, 'stats').week;

    // if (!matchup) matchup = selectMatchupsState(state).matchups[0].game_id;
    const matchups = selectMatchupsState(state).matchups;
    if (!matchup || !matchups.length || !matchups.find(match => match.game_id === matchup)) {
      console.log('reloading matchups');
      await dispatch(loadMatchups(year, week));

      const defaultMatchup = selectMatchupsState(getState()).matchups[0];
      matchup = (typeof defaultMatchup !== 'undefined') ? defaultMatchup.game_id : null;
      // matchup = selectMatchupsState(getState()).matchups[0].game_id;
    }
     // Needs to await otherwise data won't load on SSR
    await dispatch(loadBoxScores(year, formulaId, team, week, filterType, matchup));
    await dispatch(loadToolDescriptions());
  },
};



// WEBPACK FOOTER //
// ./src/app/views/BoxScores/module/boxScores.js